/**
 * @Description V2Container的children内容
 */
import { FC, useState, useEffect, useContext, useMemo, useRef } from 'react';
import { areaDetailLegend } from '@/common/api/siteselectionmap';
import { getModelClusterPopulation } from '@/common/api/networkplan';
import { useMethods } from '@lhb/hook';
import { deepCopy, isArray } from '@lhb/func';
import { globalAlias } from '@/common/utils/ways';
// import { isNotEmptyAny } from '@lhb/func';
// import cs from 'classnames';
import styles from '../index.module.less';
import HistoryTask from './HistoryTask';
import FirstScreenMap from './FirstScreenMap';
import FirstScreenRight from './FirstScreenRight';
// import LazyLoad from '@/common/components/LazyLoad';
import ShopOfPoints from './ShopPoints';
import TypeOfBusiness from './TypeOfBusiness/TypeOfBusiness';
// import POIMating from './TypeOfBusiness/POIMating';
// import PassengerFlowPortrait from '@/views/iterate/pages/siteselectionmap/components/AreaDetailDrawer/PassengerFlowPortrait';
import PassengerFlowPortrait from '@/common/components/business/PassengerFlowPortrait';
import UserInfoContext from '@/layout/context';

import { demoForCarModelIds } from '@/views/iterate/pages/siteselectionmapb/ts-config';
import AdaptiveTaskCreate from '../../ExpandStore/AdaptiveTaskCreate';

const Main: FC<any> = ({
  drawerData,
  mainHeight,
  detail,
  overViewData,
  historyVisible,
  isMallType,
  modelConfigId,
  setHistoryVisible,
  showCreateDrawer,
  setShowCreateDrawer,
  getDetail,
  pointDrawerData,
  viewChanceDetail,
  setPointDrawerData, // 点位抽屉开关
  configSwitch,
  setGatherClientPoint, // 集客点按钮展示权限与状态
  gatherList, // 集客点列表数据
  gatherClientLegendList, // 集客点图例数据
  editModalData,
  isSemirModel = false,
  detailLevel = 0, // 商圈详情层级
}) => {
  const [mapIns, setMapIns] = useState<any>(null); // 地图实例
  const [tmpLegendData, setTmpLegendData] = useState<any>([]); // 图例原始数据
  const [storeOptions, setStoreOptions] = useState<any>({}); // 经营门店所有tab展示选项
  const [surroundingOptions, setSurroundingOptions] = useState<any>({}); // 周边配套所有tab展示选项
  const [storeChecked, setStoreChecked] = useState<any>({}); // 经营门店选中项
  const [surroundingChecked, setSurroundingChecked] = useState<any>({}); // 周边配套选中项
  const [ageDetail, setAgeDetail] = useState<any>({}); // 年龄分布
  const [curDetail, setCurDetail] = useState<any>(null);// 经营门店或周边配套选中的表格项
  const [isOpenHeatMap, setIsOpenHeatMap] = useState<boolean>(false);// 是否打开热力

  const { tenantInfo: { globalAliasItemVOs }, mapConfig } = useContext(UserInfoContext); // 租户信息

  const rangeMarkerRef = useRef<any>({
    markerOf500: null,
    markerOf1500: null,
    markerOf3000: null,
  });

  const chancepointAlias = useMemo(() => {
    return globalAlias(globalAliasItemVOs);
  }, [globalAliasItemVOs]);

  useEffect(() => {
    const { id } = detail || {};
    if (id) {
      methods.loadLegend();
      methods.loadAgeDetail();
    }
  }, [detail]);

  /**
   * @description 图例展示项，只展示有数据的类型
   *
   *  tmpLegendData 接口返回图例/api/surround/poi/legend
   *  storeOptions 所有展示的门店类型 接口获取/api/surround/poi/level_count
   *  surroundingOptions 所有展示的周边配套类型 接口获取/api/surround/model/arroundCategory
   * @return
   */
  const legendData = useMemo(() => {
    if (!isArray(tmpLegendData)) return [];
    const legendList = deepCopy(tmpLegendData);
    const stores = isArray(storeOptions) ? storeOptions : [];
    const surrounds = isArray(surroundingOptions) ? surroundingOptions : [];
    if (gatherClientLegendList?.length) {
      legendList.unshift({
        automaticSwitch: false,
        code: null,
        // distance: 500,
        // distanceStr: '围栏内',
        handSwitch: false,
        key: 'GATHER_CLIENT',
        name: '集客点',
        surroundCodes: null
      });
    }

    const list = legendList.filter((itm: any) => {
      const { key, code, aoiTypeCategoryId } = itm;
      // 机会点图例，或者属于有数据展示的门店类型，周边配套
      const isGatherClient = key === 'GATHER_CLIENT';
      // 机会点图例，或者属于有数据展示的门店类型，周边配套
      const isStandardShop = ['MALL_STANDARD_SHOP', 'STANDARD_SHOP'].includes(key);
      const isChance = ['MALL_CHANCE_POINT', 'CHANCE_POINT'].includes(key);
      const isStores = !!code && stores.some((st: any) => st.code === code);
      const isSurround = surrounds.some((srd: any) => srd.id === aoiTypeCategoryId);
      return isGatherClient || isStandardShop || isChance || isStores || isSurround;
    });
    return list;
  }, [tmpLegendData, storeOptions, surroundingOptions, gatherClientLegendList]);
  const methods = useMethods({
    loadAgeDetail: async () => {
      const ageDetailRes = await getModelClusterPopulation({ id: detail.id });
      setAgeDetail(ageDetailRes);
    },
    loadLegend: async () => {
      const data = await areaDetailLegend({
        clusterId: detail.id,
        modelConfigId
      });
      const targetData = (isArray(data) ? data : []).map((item) => ({
        ...item,
        handSwitch: false, // 记录手动开关
        automaticSwitch: false, // 记录自动开关
      }));
      setTmpLegendData(targetData);
    }
  });
  return (
    <div
      className={styles.mainCon}
      style={{
        height: mainHeight,
        overflow: 'auto'
      }}
    >
      <div
        className={styles.firstScreenCon}
        style={{
          height: mainHeight,
        }}
      >
        {/* 地图部分 */}
        <FirstScreenMap
          detail={detail}
          mainHeight={mainHeight}
          mapIns={mapIns}
          storeChecked={storeChecked}
          chancepointAlias={chancepointAlias}
          surroundingChecked={surroundingChecked}
          legendData={legendData}
          isMallType={isMallType}
          modelConfigId={modelConfigId}
          setMapIns={setMapIns}
          curDetail={curDetail}
          setCurDetail={setCurDetail}
          rangeMarkerRef={rangeMarkerRef}
          isOpenHeatMap={isOpenHeatMap}
          gatherClientLegendList={gatherClientLegendList}
          mapConfig={mapConfig}
        />
        {/* 首屏右侧区域内容 */}
        <FirstScreenRight
          viewChanceDetail={viewChanceDetail}
          detail={detail}
          chancepointAlias={chancepointAlias}
          overViewData={overViewData}
          setStoreChecked={setStoreChecked}
          setSurroundingChecked={setSurroundingChecked}
          curDetail={curDetail}
          setCurDetail={setCurDetail}
          setStoreOptions={setStoreOptions}
          setSurroundingOptions={setSurroundingOptions}
          mapIns={mapIns}
          rangeMarkerRef={rangeMarkerRef}
          setIsOpenHeatMap={setIsOpenHeatMap}
          configSwitch={configSwitch}
          setGatherClientPoint={setGatherClientPoint}
          gatherList={gatherList}
          editModalData={editModalData}
          isSemirModel={isSemirModel}
          modelConfigId={modelConfigId}
          detailLevel={detailLevel}
        />
      </div>

      {/* 非首屏的懒加载区域 */}
      <div style={{ padding: '0 40px' }}>
        {/* TODO 参照这个文件src/views/iterate/pages/siteselectionmap/components/AreaDetailDrawer/index.tsx下的tabs，找到对应模块迁移过去 */}
        {/* 点位模块 */}
        {detail?.siteLocationNum
          ? <ShopOfPoints
            num={detail?.siteLocationNum}
            clusterId={drawerData.id}
            pointDrawerData={pointDrawerData}
            setPointDrawerData={setPointDrawerData}
            modelConfigId={modelConfigId}
          />
          : ''
        }
        {/* 业态&配套分析 */}
        {demoForCarModelIds.includes(modelConfigId)
          ? <></>
          : <>
            <TypeOfBusiness detail={detail}/>
            {/* https://confluence.lanhanba.com/pages/viewpage.action?pageId=172099097 产品说三代也不要了 */}
            {/* <POIMating detail={detail}/> */}
          </>}

        {/* 客流画像 */}
        <PassengerFlowPortrait ageDetail={ageDetail} overViewData={overViewData} needHelp/>
      </div>

      <HistoryTask
        open={historyVisible}
        setOpen={setHistoryVisible}
        modelClusterId={detail.id}
      />
      {/* 创建拓店任务 */}
      {
        showCreateDrawer && <AdaptiveTaskCreate
          showCreateDrawer={showCreateDrawer}
          setShowCreateDrawer={setShowCreateDrawer}
          businessInfo={detail}
          isBusiness={true}
          refresh={getDetail}
        />
      }
    </div>
  );
};

export default Main;

